import { setupBugsink } from '@common/utils/bugsink';
import { config } from './config';

setupBugsink({
  dsns: config.bugsinkDsns,
  version: config.version,
});

import './components/tef-coms'; // eslint-disable-line -- this line must come last
// 22.04.2024 force rebuild
